import { useContext } from "react";
import { Redirect, Route, RouteProps } from "react-router";

import { AuthenticationContext } from "./context/AuthenticationContext";

export { Route } from "react-router";

interface PrivateRouteProps {
  component: React.ComponentType<any>;
  path: string;
  exact?: boolean;
  role?: number;
}

export function PrivateRoute({
  component: Component,
  role,
  ...rest
}: PrivateRouteProps) {
  const { authenticatedUser } = useContext(AuthenticationContext);
  const allowedRoles = [1, 4];

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!authenticatedUser) {
          // Not authenticated
          return <Redirect to="/login" />;
        }

        // Check if route requires admin and user is not admin
        if (
          role != null &&
          !allowedRoles.includes(Number(authenticatedUser.roleId))
        ) {
          return <Redirect to="/" />;
        }

        return <Component {...props} />;
      }}
    />
  );
}

export function AuthRoute({ component: Component, ...rest }) {
  const { authenticatedUser } = useContext(AuthenticationContext);

  return (
    <Route
      {...rest}
      render={(props) => {
        return authenticatedUser ? (
          <Redirect to="/" />
        ) : (
          <Component {...props} />
        );
      }}
    />
  );
}
